import { Button, InlineLoading } from '@carbon/react';
import { FC } from 'react';

import { StepperFooterProps } from './types';
import styles from './stepper-footer.module.scss';

/**
 * Fixed footer with Cancel, Back, and Next/Submit buttons.
 * Handles loading state display on the Next button.
 *
 * @param {StepperFooterProps} props - Footer props from useStepper
 * @return {JSX.Element} The rendered footer
 */
const StepperFooter: FC<StepperFooterProps> = ({
  isNextEnabled,
  isBackEnabled,
  loadingAction,
  nextLabel,
  onCancel,
  onBack,
  onNext,
}) => {
  const isLoading = loadingAction !== null;

  return (
    <footer className={styles.footer}>
      <Button
        className={styles.cancelButton}
        kind="ghost"
        size="xl"
        disabled={isLoading}
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        className={styles.actionButton}
        kind="secondary"
        size="xl"
        disabled={!isBackEnabled || isLoading}
        onClick={onBack}
      >
        Back
      </Button>
      <Button
        className={styles.actionButton}
        kind="primary"
        size="xl"
        disabled={!isNextEnabled || isLoading}
        onClick={onNext}
      >
        <span className={styles.nextButton}>
          {loadingAction === 'next' && <InlineLoading status="active" />}
          {nextLabel}
        </span>
      </Button>
    </footer>
  );
};

export { StepperFooter };
